import { Box } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import { employeeLegalEntityId } from 'modules/core/lib/employeeLegalEntity'

import FormWrapper from 'modules/contracts/components/FlowPage/FormWrapper'
import { useLegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import type Employee from 'modules/employees/store/models/Employee'
import canSeeIntegration from 'modules/marketplace/lib/canSeeIntegration'
import integrationCodes from 'modules/marketplace/lib/integrationCodes'

import {
  AgreementCodeA3Innuva,
  ClassificationA3Innuva,
  CnoOcuppationA3Innuva,
  ContributionTypeA3Innuva,
  OccupationCodeA3Innuva,
  RegimeA3Innuva,
} from './A3innuvaFields'
import CotizationGroup from './_CotizationGroup'
import EducationLevel from './_EducationLevel'
import ProfessionalCategory from './_ProfessionalCategory'

interface Props {
  form: Form
  translations: { [key: string]: string }
  employee: Employee
}

const SpainLegalAndExtras = ({ form, translations, employee }: Props) => {
  const { spanishContractData } = useLegalEntityContractData()

  const canSeeA3InnuvaIntegration = Boolean(
    canSeeIntegration(integrationCodes.a3innuva, spanishContractData.companyInstallations)
  )
  const legalEntityId = employeeLegalEntityId(employee)

  return (
    <FormWrapper>
      <Box gap="s24">
        <EducationLevel
          canSeeA3InnuvaIntegration={canSeeA3InnuvaIntegration}
          form={form}
          translations={translations}
        />
        {canSeeA3InnuvaIntegration && (
          <>
            <AgreementCodeA3Innuva
              translations={translations}
              form={form}
              spanishContractData={spanishContractData}
              legalEntityId={legalEntityId}
            />

            <ClassificationA3Innuva
              translations={translations}
              form={form}
              legalEntityId={legalEntityId}
              spanishContractData={spanishContractData}
            />

            <ContributionTypeA3Innuva form={form} spanishContractData={spanishContractData} />
          </>
        )}
        <ProfessionalCategory
          professionalCategories={spanishContractData.professionalCategories}
          form={form}
          translations={translations}
        />
        {canSeeA3InnuvaIntegration && (
          <>
            <RegimeA3Innuva
              translations={translations}
              form={form}
              spanishContractData={spanishContractData}
              legalEntityId={legalEntityId}
            />

            <OccupationCodeA3Innuva
              form={form}
              spanishContractData={spanishContractData}
              legalEntityId={legalEntityId}
            />

            <CnoOcuppationA3Innuva
              form={form}
              spanishContractData={spanishContractData}
              legalEntityId={legalEntityId}
            />
          </>
        )}

        <CotizationGroup
          translations={translations}
          cotizationsGroups={spanishContractData.cotizationGroup}
          form={form}
          loading={spanishContractData.loading}
        />
      </Box>
    </FormWrapper>
  )
}

export default observer(SpainLegalAndExtras)
